export default "__VITE_ASSET__DjF5Iynl__"